import React from "react";
import axios from "axios";
import { Grid, Card, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "@mantine/core";

import { EmptyMessage } from "@components/shared";
export default function UserIdentityList({ reqInfo = {} }) {
  if (!reqInfo.user_id) return null;

  const { data: userIdentities = [], isLoading } = useQuery({
    queryKey: ["userIdentities", reqInfo.user_id],
    refetchOnMount: true,
    staleTime: 0,
    queryFn: async () =>
      axios
        .post(`/users/${reqInfo.user_id}/retrieve-user-identities/`, reqInfo)
        .then((res) => res.data.response)
        .catch((err) => {
          throw err;
        }),
  });

  if (isLoading) return <Loader size="xs" color="gray" />;

  if (userIdentities.length === 0)
    return (
      <EmptyMessage
        title="No user identities"
        text="This user doesn't have any user identities."
      />
    );

  return (
    <Grid>
      {userIdentities.map((identity) => (
        <Grid.Col span={{ base: 12, md: 6 }} key={identity.id}>
          <Card>
            <Text fw={600}>{identity.organization_name}</Text>
            <Text>{identity.variety_formatted}</Text>
            <Text>{identity.third_party_ident}</Text>
          </Card>
        </Grid.Col>
      ))}
    </Grid>
  );
}
